import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ArrowCircleRightIcon(props: IconProps) {
    return <Icon {...props} iconKey={"arrow_circle_right"}/>
}
